import { requestGet, requestPostFileBlob, requestPostFile } from "../config/Api";

const name = "contributors/arca";

export const getContributorArca = (params) => {
  return requestGet(name, { params });
};

export const createUploadContributor = async (data) => {
  return await requestPostFileBlob("contributors/arca/import/export", data);
};

export const createUpload = (data) => {
  return requestPostFile('contributors/arca/upload/database', data);
};
